window.message_toggle = function(jqEvent) {
  jqEvent.preventDefault();
  // alert 'hi'
  const details_selector = $(this).data('toggle');
  $(details_selector).slideToggle();
  $(this).toggleClass('closed open');
  const parent_selector = $(this).data('parent-selector');
  $(`${parent_selector} span.message-excerpt`).toggle();
};

$(function() {
  $(document).on("ajax:beforeSend", 'form.new_message', function(evt, xhr, settings) {
    $(this).find('div.spinner').hide();
  });

  $(document).on('ajax:complete', 'form.new_message', function(evt, xhr, settings) {
    $(this).find('div.spinner').hide();
  });

  $('.message-tags').each(function(idx, item) {
    $(item).tokenInput('/admin/message-tags.json', {
      crossDomain: false,
      prePopulate: $(item).data('pre'),
      theme: 'facebook'
    });
  });
});